import { Component, Input } from '@angular/core';
import {
	SnapshotHardwareComponents,
	SnapshotSoftwareComponents,
} from '../../../enums/snapshot.enum';
import { SnapshotMainComponentElementList } from '../../../models/snapshot.interface';

@Component({
	selector: 'vtr-ui-snapshot-item-list',
	templateUrl: './ui-snapshot-item-list.component.html',
	styleUrls: ['./ui-snapshot-item-list.component.scss'],
})
export class UiSnapshotItemListComponent {
	@Input() hostPage: string;
	@Input() title: string;
	@Input() snapshotComponents: Array<SnapshotMainComponentElementList>;
	@Input() componentType: string;

	constructor() {}
}
